import * as React from "react";

// dtos
import {WorkflowStatusDto, RoleDto, WorkflowDto, WorkflowStatusDtoType} from "../../../services/Client";

// components
import {Card} from "semantic-ui-react";
import WorkflowState from "./WorkflowState";
import TextField from "../../../components/TextField";
import {t} from "i18next";

interface IWorkflowProps {
    roles: RoleDto[];
    workflow: WorkflowDto;
    edit: boolean;
    setWorkflow: (workflow: WorkflowDto) => void;
    allEditorsSelected: boolean;
}

export class Workflow extends React.Component<IWorkflowProps> {

    constructor(props: IWorkflowProps) {
        super(props);
    }

    createEmptyWorkflowStatus(workflow: WorkflowDto, role: RoleDto, sequenceNumber: number, type?: WorkflowStatusDtoType): WorkflowStatusDto {
        if (type === undefined) {
            type = WorkflowStatusDtoType.MAINTENANCE;
        }
        // need a copy because of circular json dependency
        let copyWf: WorkflowDto = {
            objectId: workflow.objectId,
            versionId: workflow.versionId,
            name: workflow.name,
            partition: workflow.partition,
            type: workflow.type
        };

        return {
            objectId: 0,
            versionId: 0,
            sequenceNumber: sequenceNumber,
            name: "",
            role: role,
            type: type,
            resetPoint: sequenceNumber === 0,
            workflow: copyWf
        };
    }

    setSequenceNumberAddState(status: WorkflowStatusDto[], index: number): WorkflowStatusDto[] {
        let statusValues: WorkflowStatusDto[] = status;
        for(var i=index+1; i<status.length; i++)    {
            statusValues[i].sequenceNumber++;
        }
        return statusValues;
    }

    setSequenceNumberDeleteState(status: WorkflowStatusDto[], index: number): WorkflowStatusDto[] {
        let statusValues: WorkflowStatusDto[] = status;
        for(var i=index; i<status.length; i++)    {
            statusValues[i].sequenceNumber--;
            statusValues[i].resetPoint = statusValues[i].sequenceNumber === 0 ? true : statusValues[i].resetPoint;
        }
        return statusValues;
    }

    addAfterIndex(idx: number) {
        let {workflow} = this.props;
        if (workflow.status) {
            workflow.status.splice(idx + 1, 0, this.createEmptyWorkflowStatus(workflow, this.props.roles[0], idx + 1));
            workflow.status = this.setSequenceNumberAddState(workflow.status, idx+1);
            if(this.props.allEditorsSelected && workflow.resetRoles) {
                workflow.resetRoles = workflow.resetRoles.filter( role => role.objectId !== this.props.roles[0].objectId);
            }
            this.props.setWorkflow(workflow);
        }
    }

    deleteState(idx: number) {
        let {workflow} = this.props;
        if (workflow.status) {
            workflow.status.splice(idx, 1);
            workflow.status = this.setSequenceNumberDeleteState(workflow.status, idx);
            this.props.setWorkflow(workflow);
        }
    }

    renderStates(states: WorkflowStatusDto[] | undefined) {
        if (!states) {
            return <div />;
        }
        return states.map((val, idx) => {
            return (
                <WorkflowState
                    edit={this.props.edit}
                    roles={this.props.roles}
                    workflowState={val}
                    workflowType={this.props.workflow.type}
                    key={idx}
                    addState={() => {
                        this.addAfterIndex(idx);
                    }}
                    deleteState={() => {
                        this.deleteState(idx);
                    }}
                    onChange={(v: WorkflowStatusDto) => {
                        let {workflow} = this.props;
                        if (workflow.status) {
                            workflow.status[idx] = v;
                            if(this.props.allEditorsSelected && workflow.resetRoles) {
                                workflow.resetRoles = workflow.resetRoles.filter( role => role.objectId !== v.role.objectId);
                            }
                            this.props.setWorkflow(workflow);
                        }
                    }}
                    {...this.props}
                />
            );
        });
    }

    renderName() {
        return (
            <div>
                <div className="WorkflowHeadline">
                    {t("WORKFLOW:WORKFLOW_STATE_NAME")}
                </div>
                <TextField
                    id="workflow-name-input"
                    disabled={!this.props.edit}
                    value={this.props.workflow.name}
                    onBlur={(e: any, d: any) => {
                        let {workflow} = this.props;
                        if (workflow.name !== d) {
                            workflow.name = d;
                            this.props.setWorkflow(workflow);
                        }
                    }}
                />
            </div>
        );
    }

    render() {
        return (
            <Card.Group className="workflow_card_group">
                {this.renderStates(this.props.workflow.status)}
            </Card.Group>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/AdminView/WorkflowTab/Workflow.tsx